import { render, staticRenderFns } from "./TekBolim.vue?vue&type=template&id=77ffa68e"
import script from "./TekBolim.vue?vue&type=script&lang=js"
export * from "./TekBolim.vue?vue&type=script&lang=js"
import style0 from "./TekBolim.vue?vue&type=style&index=0&id=77ffa68e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports